export const BP_PHONE_PARAMS = ["user_phone", "user_contact_phone"];
